export const isStatic = () => window.location.href.includes("static=true");
